module.exports = __webpack_public_path__ + "static/media/Car.6deca3ed.svg";